<template>
  <div class="errors">
    <div class="error--main">
      <div class="error__title">
        <span v-if="errors.main.code"
          >{{ errors.main.code }}: </span
        >
        {{ errors.main.title }}

      </div>
      <div class="error__message">{{ errors.main.message || hint }}</div>
      <div
        tabindex="0"
        class="btn btn--primary"
        v-show="showButton"
        id="errorBtn"
        @click="handleErrorBtnClick(errors.main.btnLink)"
      >
        {{ errors.main.btnText }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hint: 'Versuchen Sie es erneut oder wenden Sie sich an support@eligo.de.',
    };
  },
  
  mounted() {
      if (this.errors.main.disableClose) {
        this.$emit('disableClose');
      }
  },

  watch: {
    errors () {
      if (this.errors.main.disableClose) {
        this.$emit('disableClose');
      }
    }
  },


  computed: {
    showButton () {
      return this.errors.main.showBtn && !this.$store.state.isOnSite && !this.$route.query['on-site'];
    },
    errors() {
      const cerr = this.$store.state.errors.find( err => ['C02','C03','C23','C22'].includes(err.code ));
      const [main = {}, ...all] = this.$store.state.errors;
      return { main: cerr || main, all };
    },
  },

  methods: {
    handleErrorBtnClick(link) {
      if (link) {
        // link kann extern oder interner sein, intern muss immer /${cstm}/ vorangestellt sein
        const isExternal = /^http/;
        if (!isExternal.test(link)) {
          let cstm = this.$store.state.cstm;
          const isValidInternal = new RegExp(`^/${cstm}/`);
          if (!isValidInternal.test(link)) {
            link = '/' + cstm + (link.charAt(0) == '/' ? link : '/' + link);
          }
        }
        window.location.href = link;
      } else {
        // wenn kein Link angegeben, schliesse Error-Anzeige
        this.$store.dispatch('hideError', { root: true });
        this.$emit('close');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.error--main {
  display: flex;
  flex-direction: column;
  .error {
    &__title {
      font-size: 1.5rem;
      background-color: var(--primary-light);
      height: 50%;
      padding: 1.5rem 2rem;
      color: var(--white);
    }
    &__message {
      font-size: 1rem;
      padding: 1.5rem;
      background-color: var(--white);
    }
  }
}
#errorBtn {
  margin: 2em auto;
}
</style>
